import { render, staticRenderFns } from "./FiscalizationTriggersTab.vue?vue&type=template&id=25eb244a&scoped=true&"
import script from "./FiscalizationTriggersTab.vue?vue&type=script&lang=js&"
export * from "./FiscalizationTriggersTab.vue?vue&type=script&lang=js&"
import style0 from "./FiscalizationTriggersTab.vue?vue&type=style&index=0&id=25eb244a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb244a",
  null
  
)

export default component.exports